import { apiClient, shopMobilePath } from './client';

export interface InventoryItem {
  id: string;
  name: string;
  sku: string | null;
  category: string | null;
  unit: string;
  stockQty: number;
  warningQty: number;
  unitPrice: string;
  remark: string | null;
  warning: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface InventoryListResult {
  items: InventoryItem[];
  total: number;
  warningCount: number;
}

export interface InventoryRecord {
  id: string;
  itemId: string;
  itemName: string;
  type: 'inbound' | 'outbound' | 'adjust' | 'return';
  qty: number;
  beforeQty: number;
  afterQty: number;
  orderId: string | null;
  supplierId: string | null;
  warrantyYears: number | null;
  operatorId: string | null;
  remark: string | null;
  createdAt: string;
}

export function getInventoryItems(search?: string) {
  // Backend uses `q` param for search
  const path = search
    ? `/inventory/items?q=${encodeURIComponent(search)}`
    : '/inventory/items';
  return apiClient.get<InventoryListResult>(shopMobilePath(path));
}

export function createInventoryItem(input: {
  name: string;
  sku?: string;
  category?: string;
  unit?: string;
  stockQty?: number;
  warningQty?: number;
  unitPrice?: string;
  remark?: string;
}) {
  return apiClient.post<InventoryItem>(shopMobilePath('/inventory/items'), input);
}

export function updateInventoryItem(
  itemId: string,
  input: Partial<{
    name: string;
    sku: string;
    category: string;
    unit: string;
    warningQty: number;
    unitPrice: string;
    remark: string;
  }>,
) {
  return apiClient.patch<InventoryItem>(
    shopMobilePath(`/inventory/items/${itemId}`),
    input,
  );
}

export function deleteInventoryItem(itemId: string) {
  return apiClient.delete(shopMobilePath(`/inventory/items/${itemId}`));
}

export function adjustInventoryStock(
  itemId: string,
  input: {
    type: 'inbound' | 'outbound' | 'adjust' | 'return';
    qty: number;
    remark?: string;
  },
) {
  return apiClient.post<{ itemId: string; newStockQty: number; recordId: string }>(
    shopMobilePath(`/inventory/items/${itemId}/adjust`),
    input,
  );
}

export function getInventoryRecords(itemId?: string) {
  const path = itemId
    ? `/inventory/records?itemId=${encodeURIComponent(itemId)}`
    : '/inventory/records';
  return apiClient.get<InventoryRecord[]>(shopMobilePath(path));
}
